import React from 'react';
import { FloComponentProps } from 'components';
import styles from './UnitDetailHead.module.css';
import { useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import { Location} from 'model';
import { Link } from 'react-router-dom';

interface UnitDetailHeadProps extends FloComponentProps {
  unit?: Location,
}

export const UnitDetailHead: React.FC<UnitDetailHeadProps> = React.memo(({
  unit,
}) => {
  const { t } = useTranslation();

  return (
    <>
      { unit ?
        <Col xs="12">
          <Link to={`/locations${(unit.parent) ? `/${unit.parent.id}` : ''}`}>
          <div className={styles.arrow}>
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.90735e-05 6.99921C0.0137634 6.84236 0.0756111 6.63369 0.175945 6.51569L5.45372 0.252925C5.68462 -0.0737411 6.1588 -0.0737411 6.45016 0.193922C6.74292 0.461586 6.76491 0.936466 6.50926 1.21998L2.25397 6.26262H18.2963C18.6853 6.26262 19 6.59216 19 6.99941C19 7.40668 18.6853 7.73621 18.2963 7.73621H2.25397L6.50926 12.7788C6.78827 13.0609 6.70993 13.5458 6.41718 13.8135C6.12443 14.0812 5.68325 14.0625 5.4537 13.7459L0.175926 7.48313C0.0343628 7.32339 0.00824738 7.14926 0 6.9996L1.90735e-05 6.99921Z" fill="#899AA6"/>
            </svg>
          </div>
          <div className={styles.parentContainer}>
            <div className={styles.parentInfo}>
              <div className={styles.parentAddress}>{unit.nickname || unit.address}</div>
              <div className={styles.parentExtra}>{'Unit'}</div>
            </div>
          </div>
          </Link>
        </Col>
        :
        <Col xs="12" sm="12">
          <h2>{`${t('Loading Unit')}...`}</h2>
        </Col>
      }
    </>
  )
})